'use client'

import { PropsWithChildren } from 'react'
import { HeroUIProvider } from '@heroui/react'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { getQueryClient } from 'lib/utils/getQueryClient'

export function Providers({children}: PropsWithChildren) {
  const queryClient = getQueryClient()

  return (
    <HeroUIProvider>
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools initialIsOpen={false} />
        {children}
      </QueryClientProvider>
    </HeroUIProvider>
  )
}
